import script from "./TopMenuComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMenuComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TopMenuComponent.vue?vue&type=style&index=0&id=1f26d6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f26d6bc"]])

export default __exports__